// extracted by mini-css-extract-plugin
export default {"wrapper":"Ry-z","addressLine":"Sy-z","fullName":"Ty-z"};